export const DEFAULT_CELL_CLASS_RULES = {
  'grid-edited-cell': params => {
    const { colDef, data, value } = params
    const field = colDef.field ?? colDef.colId
    if (
      !data.editedData ||
      !field ||
      !colDef.editable ||
      (typeof colDef.editable === 'function' && !colDef.editable(params))
    ) {
      return false
    }
    return (
      data.editedData.hasOwnProperty(field) && value !== data.editedData[field]
    )
  },
}

export const PROJECT_PLAN_CELL_CLASS_RULES = {
  'grid-edited-cell': params => {
    const { colDef, data, value } = params
    const field = colDef.field ?? colDef.colId
    if (
      !data.editedData ||
      !field ||
      !colDef.editable ||
      (typeof colDef.editable === 'function' && !colDef.editable(params))
    ) {
      return false
    }
    if (field === 'body.wbsItem.displayName' && value.isModified) {
      return (
        data.editedData.hasOwnProperty(field) &&
        value.isModified(data.editedData[field])
      )
    }
    return (
      data.editedData.hasOwnProperty(field) && value !== data.editedData[field]
    )
  },
}
